module.exports = __webpack_public_path__ + "assets/img/title.88e8bb73.png";